
import PropTypes from 'prop-types'
import React from 'react'
import { get } from 'lodash'
import { withFirebase, withReloadable } from '../../hoc'
import { getUserInfo } from '../../utils/awsAuth'

const OrderAuditManagementContext = React.createContext({})
class OrderAuditManagement extends React.Component {
  _observer = null
  state = { events: [], loading: true, taken: false, userId: null }
  componentDidMount () {
    try {
      const { firebase, orderId } = this.props;
      this.setState({ loading: true })
      this._observer = firebase.collection('order-audits').doc(orderId)
        .onSnapshot((doc) => {
          const data = doc.data()
          this.setState({
            loading: false,
            taken: get(data, 'taken', false),
            userName: get(data, 'userName', '<user>'),
            userId: get(data, 'userId')
          })
        })
    } catch (error) {
      console.log(error)
    }
  }

  async componentWillUnmount () {
    this._observer()
  }

  render () {
    const { children } = this.props
    const { events, loading, taken, userName } = this.state;
  
    return (
      <OrderAuditManagementContext.Provider value={{ events, loading, taken, userName }}>
        {children}
      </OrderAuditManagementContext.Provider>
    )
  }
}

OrderAuditManagement.propTypes = {
  children: PropTypes.any,
  firebase: PropTypes.object,
  orderId: PropTypes.string.isRequired
}

const OrderAuditManagementActions = ({ children, firebase, orderId, ...props }) => {
  const _toggleAuditMode = async (isTaken = true) => {
    try {
      const { credentials } = await getUserInfo()
      const userId = get(credentials, 'idToken.payload.sub')
      const user = JSON.parse(get(credentials, 'idToken.payload.user', '{}'))
      const userName = `${get(user, 'name')} ${get(user, 'lastName')}`
      const resp = await firebase
        .collection('order-audits')
        .doc(orderId)
        .set({
          userId,
          userName,
          taken: isTaken
        })
    } catch (error) {
      throw error
    }
  }
  return (
    <OrderAuditManagementContext.Consumer>
      {({ toggleAudit, taken, userName, loading }) => children({ loading, toggleAudit: _toggleAuditMode, taken, userName })}
    </OrderAuditManagementContext.Consumer>
  )
}

export const OrderAuditManagementConsumer = withFirebase(OrderAuditManagementActions)

export default withReloadable(withFirebase(OrderAuditManagement), ['orderId'])
